import { render, staticRenderFns } from "./ProductCategoryDetail.vue?vue&type=template&id=5defeacc&scoped=true&"
import script from "./ProductCategoryDetail.vue?vue&type=script&lang=js&"
export * from "./ProductCategoryDetail.vue?vue&type=script&lang=js&"
import style0 from "./ProductCategoryDetail.vue?vue&type=style&index=0&id=5defeacc&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5defeacc",
  null
  
)

export default component.exports